if (!customElements.get('pickup-availability')) {
  customElements.define('pickup-availability', class PickupAvailability extends HTMLElement {
    constructor() {
      super();
      // Simple availability message for Parookaville
      this.innerHTML = `
        <div class="pickup-availability-info">
          <svg width="16" height="16" viewBox="0 0 20 20" fill="currentColor" style="color: #28a745;">
            <path d="M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zm-2 15l-5-5 1.41-1.41L8 12.17l7.59-7.59L17 6l-9 9z"/>
          </svg>
          <span style="color: #28a745; font-weight: 500; margin-left: 6px;">Abholung in ca. 90min</span>
        </div>
      `;
    }
  });
}

// Remove drawer functionality - not needed
if (customElements.get('pickup-availability-drawer')) {
  document.querySelectorAll('pickup-availability-drawer').forEach(el => el.remove());
}